export const MIN_ABOVE_MAX_MESSAGE = "Minimum can't be higher than maximum.";

type RangeValue = number | string | null | undefined;

const toNumber = (value: RangeValue): number | null =>
  value === null || value === undefined || value === '' ? null : Number(value);

/** True when both bounds are set and the minimum is above the maximum. */
export const isMinAboveMax = (min: RangeValue, max: RangeValue): boolean => {
  const low = toNumber(min);
  const high = toNumber(max);
  return low !== null && high !== null && low > high;
};
